<template>
	<div style="position: relative; height: auto; width: 100%; overflow: hidden;">
		<div v-if="!cameraCarregada" class="loading-camera">
			<img src="../assets/loading.gif" alt="" />
		</div>
		<video
			v-show="cameraCarregada"
			ref="videoElement"
			id="barcode-video"
			autoplay
			playsinline
			style="width: 100%; height: 100%; object-fit: cover; background-color: black; clip-path: polygon(0% 25%, 100% 25%, 100% 75%, 0% 75%);transform: translateY(-25%);"
		></video>
	</div>
</template>

<script>
import jsQR from "jsqr";

export default {
	data() {
		return {
			stream: null,
			animationFrameId: null,
			tickTimeoutId: null,
			cameraCarregada: false,
		};
	},
	mounted() {
		this.startVideo();
	},
	beforeDestroy() {
		if (this.tickTimeoutId) {
			clearTimeout(this.tickTimeoutId);
			this.tickTimeoutId = null;
		}
		if (this.animationFrameId) {
			cancelAnimationFrame(this.animationFrameId);
			this.animationFrameId = null;
		}
		if (this.stream) {
			this.stream.getTracks().forEach(track => track.stop());
			this.stream = null;
		}
	},
	methods: {
		startVideo() {
			navigator.mediaDevices
			.getUserMedia({ video: { facingMode: "environment" } })
			.then((stream) => {
				this.stream = stream;
				const videoElement = this.$refs.videoElement;
				videoElement.srcObject = stream;
				videoElement.addEventListener("canplay", () => {
					this.cameraCarregada = true;
				});
				videoElement.addEventListener("loadedmetadata", () => {
					this.processFrame();
				});
			})
			.catch((err) => {
				console.error("Erro ao acessar a câmera: ", err);
			});
		},

		processFrame() {
			const videoElement = this.$refs.videoElement;
			const canvas = document.createElement("canvas");
			const context = canvas.getContext("2d");
			let isQRCodeLido = false;

			const tick = () => {
				if (videoElement.videoWidth === 0 || videoElement.videoHeight === 0) {
					this.animationFrameId = requestAnimationFrame(tick);
					return;
				}

				canvas.width = videoElement.videoWidth;
				canvas.height = videoElement.videoHeight;
				context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

				const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
				const code = jsQR(imageData.data, canvas.width, canvas.height, {
					inversionAttempts: "dontInvert",
				});

				if (code && code.data && !isQRCodeLido) {
					isQRCodeLido = true;
					this.enviarTextoLido(code.data);
					return; // para o loop após detectar
				}

				// throttle para ~24fps — reduz carga de CPU/bateria sem perder responsividade
				this.tickTimeoutId = setTimeout(() => {
					this.animationFrameId = requestAnimationFrame(tick);
				}, 42);
			};

			this.animationFrameId = requestAnimationFrame(tick);
		},

		enviarTextoLido(code) {
			console.log("QR Code detectado:", code);
			this.$emit("onDetected", code);
		},
	},
};
</script>

<style scoped>
.loading-camera {
	display: flex;
	justify-content: center;
	align-items: center;
	background: white;
}
</style>
